import { axiosInstance as request } from '@api/rest.service'

const api = '/info-boxes'

/**
 * @description GET /info-boxes/subscription-spend-overview
 * @returns {AxiosPromise<any>}
 */
export const GET_INFO_BOX_SUB_SPEND_OVERVIEW = () => request.get(`${api}/subscription-spend-overview`)

/**
 * @description GET /info-boxes/department-spend-overview/{?id}
 * @returns {AxiosPromise<any>}
 */
export const GET_INFO_BOX_DEP_SPEND_OVERVIEW = id => {
  const param = id === null ? '' : id
  return request.get(`${api}/department-spend-overview/${param}`)
}

/**
 * @description GET /info-boxes/to-do-list
 * @returns {AxiosPromise<any>}
 */
export const GET_INFO_BOX_TODO_LIST = () => request.get('/info-boxes/to-do-list')

/**
 * @description GET /info-boxes/forecasted-subscription-cost-overview-for-financial-period/{id}
 * @returns {AxiosPromise<any>}
 */

export const GET_INFO_BOX_FORECASTED_SUBSCRIPTION_COST_OVERVIEW = id =>
  request.get(`/info-boxes/forecasted-subscription-cost-overview-for-financial-period/${id}`)

/**
 * @description GET /info-boxes/forecasted-subscription-cost-for-financial-period-recommendations-breakdown/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_RECOMMENDATIONS_TOTAL_CARD_INFO = id =>
  request.get(`${api}/forecasted-subscription-cost-for-financial-period-recommendations-breakdown/${id}`)

/**
 * @description GET /info-boxes/forecasted-subscription-cost-for-financial-period-recommendations-breakdown/{}financialPeriodId}/departments/{departmentId}
 * @returns {AxiosPromise<any>}
 */
export const GET_RECOMMENDATIONS_DEPARTMENT_CARD_INFO = (financialPeriodId, depId) =>
  request.get(
    `${api}/forecasted-subscription-cost-for-financial-period-recommendations-breakdown/${financialPeriodId}/departments/${depId}`
  )

/**
 * @description GET /info-boxes/forecasted-subscription-cost-for-financial-period-renewal-proposal-breakdown/{financialPeriodId}/departments/{depId}
 * @returns {AxiosPromise<any>}
 */
export const GET_RENEWAL_PROPOSAL_DEPARTMENT_CARD_INFO = (financialPeriodId, depId) =>
  request.get(
    `${api}/forecasted-subscription-cost-for-financial-period-renewal-proposal-breakdown/${financialPeriodId}/departments/${depId}`
  )

/**
 * @description GET /info-boxes/forecasted-subscription-cost-for-financial-period-renewal-proposal-breakdown/:financialPeriodId
 * @returns {AxiosPromise<any>}
 */
export const GET_RENEWAL_PROPOSAL_TOTAL_CARD_INFO = id =>
  request.get(`${api}/forecasted-subscription-cost-for-financial-period-renewal-proposal-breakdown/${id}`)

/**
 * @description GET /info-boxes/scenario-with-costs-and-budgets/{financialPeriodId}/departments/{departmentId}
 * @returns {AxiosPromise<any>}
 */
export const GET_SCENARIO_WITH_COSTS_AND_BUDGETS_FOR_DEPARTMENT = (fpId, depId) =>
  request.get(`${api}/scenario-with-costs-and-budgets/${fpId}/departments/${depId}`)

/**
 * @description GET /info-boxes/scenario-with-costs-and-budgets/{financialPeriodId}
 * @returns {AxiosPromise<any>}
 */
export const GET_SCENARIO_WITH_COSTS_AND_BUDGETS = fpId => request.get(`${api}/scenario-with-costs-and-budgets/${fpId}`)
